// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/views/admin.admin.show.scss
// module id = 15
// module chunks = 0